module.exports = __webpack_public_path__ + "static/media/jiaoyu_bg.29c9b888.png";